<template>
    <div class="mainbody modulewrap">
        <ffbanner :infodata="infodata"></ffbanner>
        <div class="infopage" v-if="isload">
            <div class="infoacad1">
                <div class="infoacadsub realwrap">
                    <div class="infoacadsubitem" v-for="(item2,index2) in infolist[0].x_imgs" :key="index2"><img :src="item2" /></div>
                </div>
            </div>

            <div class="infoacad3">
                <div class="infoacad2">
                    <div class="infoacadsub infoacad2aholder realwrap">
                        <div class="infoacadsubitem"></div>
                        <div class="infoacadsubitem"><img :src="infolist[2].x_imgs[0]" /></div>
                    </div>
                    <div class="infoacad2a">
                        <div class="infoacadsub realwrap">
                            <div class="infoacadsubiteminfo" v-html="$common.langinfo(infolist[1].content,infolist[1].content_en)"></div>
                        </div>
                    </div>

                </div>
                <div class="infoacadsub realwrap">
                    <div class="infoacadsubitem"></div>
                    <div class="infoacadsubitem" v-for="(item2,index2) in infolist[2].x_imgs" :key="index2"><img :src="item2" /></div>
                </div>
            </div>


        </div>
    </div>
</template>



<script>
    export default {
        name: 'academic',
        data() {
            return {
                infodata: {},
                infolist: [],
                isload: false
            };
        },
        mounted() {

            this.$common.fetch({ 'act': 'tea_infomodel', 'exts': 'kv=8' }, res => {
                this.infodata = res.infodata;
                this.$common.each(res.infodatainfo, item => {
                    if (item.imgs) {
                        item.x_imgs = item.imgs.split(',');
                    }
                    else {
                        item.x_img = [];
                    }
                });
                this.infolist = res.infodatainfo;
                this.isload = true;
            });
        }
    }
</script>
